'use strict';

angular.module('app.campaignActivity')
    .directive('campaignActivityLogs', function ($rootScope) {
        var controller = function () {
            var vm = this;
            vm.canAddNote = $rootScope.currentUser.role.accessLevel != 'influencer';
        };

        return {
            restrict: 'E',
            scope: {
                activities: '=',
                onAddNote: "&"
            },
            controller: controller,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'app/campaign/campaignActivityPage/activityLogs/campaignActivityLogs.html?app_v=deployDate'
        };
    });